import React from 'react';

import {
  Box, FieldGroup, Form, InputField, Modal, Typography, useWindowSize,
} from 'vindi-ds-components';

import { PrMinusSquare, PrPlusSquare } from 'vindi-ds-icons/pr';

import tokens from 'vindi-ds-tokens';

const ModalExport = ({ modalRef }) => {
  const initialValues = {
    export: '',
    format: '',
    subscription: [],
    subscriptionItem: [],
    subscriptionPaymentMethod: [],
    subscriptionPlan: [],
    subscriptionBill: [],
    subscriptionBillItem: [],
    subscriptionBillCharge: [],
  };

  const { isMobile } = useWindowSize();

  const [advancedOptionsOpen, setAdvancedOptionsOpen] = React.useState(false);

  const handleClickClearFilters = ({ setValues }) => {
    setValues(initialValues);
  };

  const handleSubmit = () => modalRef.current.close();

  const handleClickAdvancedOptions = () => setAdvancedOptionsOpen(
    (currentAdvancedOptionsOpen) => !currentAdvancedOptionsOpen,
  );

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleSubmit}
      id='formExport'
    >
      {(formProps) => (
        <Modal
          ref={modalRef}
          title='Exportar'
          btnPrimaryLabel='Exportar'
          btnPrimaryProps={{ form: 'formExport', type: 'submit' }}
          btnSecondaryLabel='Limpar filtro'
          btnSecondaryClick={() => handleClickClearFilters(formProps)}
          scrollMode={isMobile ? 'page' : 'modal'}
        >
          <Box mb={3}>
            <Box mb={1}>
              <Typography variant='subtitle2' color='textPrimary'>Exportar</Typography>
            </Box>

            <FieldGroup name='export' radio>
              <InputField label='Apenas página atual' value='firstPage' id='firstPage' />
              <InputField label='Todas as páginas' value='allPages' id='allPages' />
            </FieldGroup>
          </Box>

          <Box mb={4}>
            <Box mb={1}>
              <Typography variant='subtitle2' color='textPrimary'>Formato</Typography>
            </Box>

            <FieldGroup name='format' radio>
              <InputField label='CSV Simples' value='csv' id='csv' />
              <InputField label='Excel' value='excel' id='excel' />
            </FieldGroup>
          </Box>

          <Box
            display='flex'
            alignItems='center'
            color={tokens.color.brand.secondary[500].value}
            mb={4}
            style={{ cursor: 'pointer' }}
            onClick={handleClickAdvancedOptions}
            data-testid='advanced-options'
          >
            <Box display='flex' alignItems='center' mr={1}>
              {advancedOptionsOpen ? (
                <PrMinusSquare color='inherit' />
              ) : (
                <PrPlusSquare color='inherit' />
              )}
            </Box>

            <Typography variant='body2' color='inherit'>Opções avançadas</Typography>
          </Box>

          {advancedOptionsOpen ? (
            <Box>
              <Box mb={2}>
                <Typography variant='subtitle2' color='textPrimary'>Entidades - Assinatura</Typography>
              </Box>

              <Box mb={2}>
                <FieldGroup name='subscription' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Cliente</Typography>} value='customer' id='customerCustomer' />
                  <InputField label='Endereço' value='address' id='customerAddress' />
                  <InputField label='Metadado' value='metadata' id='customerMetadata' />
                </FieldGroup>
              </Box>

              <Box mb={2}>
                <FieldGroup name='subscriptionItem' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Item da assinatura</Typography>} value='subscriptionItem' id='subscriptionItem' />
                  <InputField label='Produto' value='product' id='subscriptionItemProduct' />
                </FieldGroup>
              </Box>

              <Box mb={2}>
                <FieldGroup name='subscriptionPaymentMethod' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Método de pagamento</Typography>} value='paymentMethod' id='subscriptionPaymentMethod' />
                </FieldGroup>
              </Box>

              <Box mb={3}>
                <FieldGroup name='subscriptionPlan' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Plano</Typography>} value='plan' id='plan' />
                </FieldGroup>
              </Box>

              <Box mb={2} color={tokens.color.prsm.neutral[700].value}>
                <Typography variant='body1' color='inherit' weight='bold'>Entidades - Fatura</Typography>
              </Box>

              <Box mb={2}>
                <FieldGroup name='subscriptionBill' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Fatura</Typography>} value='bill' id='subscriptionBill' />
                  <InputField label='Método de pagamento' value='paymentMethod' id='subscriptionBillPaymentMethod' />
                  <InputField label='Metadado' value='metadata' id='subscriptionBillMetadata' />
                  <InputField label='Nota Fiscal' value='invoice' id='subscriptionBillInvoice' />
                </FieldGroup>
              </Box>

              <Box mb={2}>
                <FieldGroup name='subscriptionBillItem' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Item da Fatura</Typography>} value='billItem' id='subscriptionBillItem' />
                  <InputField label='Produto' value='product' id='subscriptionBillItemProduct' />
                </FieldGroup>
              </Box>

              <Box mb={2}>
                <FieldGroup name='subscriptionBillCharge' checkbox>
                  <InputField label={<Typography variant='body2' weight='bold'>Cobrança</Typography>} value='charge' id='subscriptionBillCharge' />
                  <InputField label='Método de pagamento' value='paymentMethod' id='subscriptionBillChargePaymentMethod' />
                </FieldGroup>
              </Box>
            </Box>
          ) : null}
        </Modal>
      )}
    </Form>
  );
};

export default ModalExport;
